export default "__VITE_ASSET__BhD54w_w__"